<template>
  <div class="mypage-details-setting-section">
    <h3 v-if="title" class="mypage-details-setting-section__title">{{ title }}</h3>
    <details-data-list-parts :detailsListItems="detailsListItems" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import DetailsDataListParts from '@/components/MypageDetailsSettingPage/MypageDetailsSettingPane/parts/DetailsDataListParts.vue'

/**
 * マイページ: 詳細設定 データ セクション
 */
export default defineComponent({
  name: 'MypageDetailsSettingSection',
  components: {
    DetailsDataListParts,
  },
  props: {
    /**
     * セクションタイトル
     */
    title: {
      type: String,
    },
    /**
     * データリスト
     */
    detailsListItems: {
      type: Array,
      required: true,
    },
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.mypage-details-setting-section {
  width: 100%;
  margin-bottom: 24px;

  &__title {
    padding: 0 16px;
    margin-bottom: 8px;
    text-align: left;
    @include fontSetTextMedium(12);

    line-height: 1.67;
    color: $gray50;
  }
}
</style>
